import { render, staticRenderFns } from "./editPersonnelDetail.vue?vue&type=template&id=a12485dc&scoped=true&"
import script from "./editPersonnelDetail.vue?vue&type=script&lang=js&"
export * from "./editPersonnelDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a12485dc",
  null
  
)

export default component.exports